import { useGetTaskCategoriesQuery } from 'app/api';
import { selectSelectedEnvId } from 'app/containers/HiikoEnv/slice/selectors';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { TextSemibold14 } from 'styles/typography';
import { getTaskStatusText } from 'utils/helpers';
import { ITaskFilters, taskFilterEnum } from '../../slice/types';

import * as S from './TaskListTableFilterTags.styles';

interface IProps {
  filters: ITaskFilters;
  setFilters: (filters: ITaskFilters) => void;
}

const TaskListTableFilterTags: FC<IProps> = ({ filters, setFilters }) => {
  const { t } = useTranslation();
  const envId = useSelector(selectSelectedEnvId) as number;

  const onClose = (name: taskFilterEnum) => {
    setFilters({ [name]: undefined });
  };

  const { data: taskCategories } = useGetTaskCategoriesQuery({ envId });

  const taskCategoryName = taskCategories?.find(
    category => category.id === Number(filters.categoryId),
  )?.name;

  if (
    !filters.startDate &&
    !filters.endDate &&
    !filters.status?.length &&
    !filters.categoryId
  ) {
    return null;
  }

  return (
    <S.FiltersSpace align="center">
      <TextSemibold14>
        {t('Task.ListTableFilterTags.ActiveFilters', 'Active filters:')}
      </TextSemibold14>

      {filters.startDate && (
        <S.FilterTag
          closable
          color="blue"
          onClose={() => {
            onClose(taskFilterEnum.startDate);
          }}
          visible={true}
        >
          {t('Task.ListTableFilterTags.FromDate', {
            defaultValue: 'From {{date}}',
            date: filters.startDate,
          })}
        </S.FilterTag>
      )}
      {filters.endDate && (
        <S.FilterTag
          closable
          color="blue"
          onClose={() => {
            onClose(taskFilterEnum.endDate);
          }}
          visible={true}
        >
          {t('Task.ListTableFilterTags.TillDate', {
            defaultValue: 'Till {{date}}',
            date: filters.endDate,
          })}
        </S.FilterTag>
      )}

      {filters.status?.map(status => (
        <S.FilterTag
          closable
          color="blue"
          onClose={() =>
            setFilters({
              [taskFilterEnum.status]: filters.status!.filter(
                filterStatus => filterStatus !== status,
              ),
            })
          }
          visible={true}
        >
          {getTaskStatusText(status)}
        </S.FilterTag>
      ))}

      {taskCategoryName && (
        <S.FilterTag
          closable
          color="blue"
          onClose={() => onClose(taskFilterEnum.categoryId)}
          visible={true}
        >
          {taskCategoryName}
        </S.FilterTag>
      )}
    </S.FiltersSpace>
  );
};

export default TaskListTableFilterTags;
